import { RightOutlined } from '@ant-design/icons';
import { Descriptions, Image, Row } from 'antd';
import { Link } from 'react-router-dom';

interface ICard {
    img?: string,
    productName?: string;
    UPC?: number | string;
    id?: number;
    warehouseName?: string;
    warehouseAddress?: string;
    quantity?: number;
}

const ListStockDashboard = (props: ICard) => {
    
    return (
        <div style={{ padding: '1rem' }}>
            <Row className="card-item width-img">
            <img width={80} height={80} src={!!props.img ? props.img : "/images/image.svg" } />
            <Descriptions>
                <Descriptions.Item>상품 코드 {props.UPC}</Descriptions.Item>
                <Descriptions.Item>{props.productName}</Descriptions.Item>
            </Descriptions>
            <Descriptions>
                <Descriptions.Item>{props.warehouseName}</Descriptions.Item>
                <Descriptions.Item>{!!props.warehouseAddress ? props.warehouseAddress :"Singapore"}</Descriptions.Item>
            </Descriptions>
            <Descriptions>
                <Descriptions.Item>
                잔여 재고  &nbsp; {(props.quantity && props.quantity > 0 ) ? props.quantity : "00개"}
                {/* <span style={{ marginLeft: '30px' }}>{props.amountNumber}개</span> */}
                </Descriptions.Item>
            </Descriptions>
            <Link to={`/admin/seller/stock-detail/${props.id}`}>
                <RightOutlined style={{ marginLeft: '1rem' }} />
            </Link>
            </Row>
        </div>
    )
}

export default ListStockDashboard